// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"0bf86c3f","76":"f882e4d6","123":"33d3dcbf","243":"37466128","343":"c4b578f8","364":"b91f0c4d","433":"049b8237","435":"88892d88","444":"8e701a8e","484":"23e52407","487":"616d27ac","529":"a9a6e366","540":"b0141fd9","625":"e4f43463","683":"6180ea0f","912":"0ebca15d"}[chunkId] + ".chunk.js";
};